/* eslint-disable no-prototype-builtins */
import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
} from 'react';
import {
    useNavigate,
    useParams,
    // useLocation,
} from 'react-router-dom';
// import clsx from 'clsx';
import { toast } from 'react-toastify';
import {
    has as _has,
    // isEqual as _isEqual,
    cloneDeep as _cloneDeep,
} from 'lodash';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import Groups from './groups';
import Rules from './rules';
import Rule from './rule';
import Push from '../../../../components/push';

import Auth from '../../../../data/auth-service';
import PolicyService from '../../../../data/policy-service';
import SuricataService from '../../../../data/suricata-service';
import Animations from '../../../../libraries/animations';

const useStyles = makeStyles(theme => ({
    justifySpace: {
        justifyContent: 'space-between',
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
    },
    suriDetails: {
        width: '150px',
        padding: theme.spacing(1),
        background: theme.styled.paper.background,
        marginRight: theme.spacing(1),
        textAlign: 'center',
        '& .MuiBox-root': {
            marginTop: theme.spacing(1),
            fontSize: '24px',
        }
    },
    controlBar: {
        display: 'none',
    },
    hidePadding: {
        padding: '0px !important',
    },
    readonlyWarning: {
        background: theme.styled.paper.background,
        marginLeft: theme.spacing(4),
        border: `1px solid ${theme.palette.warning.main}`,
        padding: theme.spacing(2),
    },
    ...Animations.Push(theme),
}));

const UPDATER = {
    search: '',
    rule_search: '',
    group_search: '',
    exact: false,
    groups: {},
    rules: {},
    selector_group: {},
    modifier_group: {},
    selector_rule: {},
    modifier_rule: {},
};

const SEARCH = {
    search: '',
    // rule_search: '',
    // group_search: '',
    exact: false,
    sort: 'name asc',
    page: 0,
    limit: 50,
    group: '',
};

const SuricataRules = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const params = useParams();
    // const location = useLocation();
    const [shadow, setShadow] = useState(null);
    const [groups, setGroups] = useState({ enabled_enabled_rules: 0, groups: [] });
    const [rules, setRules] = useState({ enabled_enabled_rules: 0, rules: [] });
    const [selectedGroup, setSelectedGroup] = useState('');
    const [prevGroup, setPrevGroup] = useState('');
    // const [search, setSearch] = useState({});
    const [groupSearch, setGroupSearch] = useState(_cloneDeep({ ...SEARCH }));
    const [ruleSearch, setRuleSearch] = useState(_cloneDeep({ ...SEARCH }));
    const [updater, setUpdater] = useState(_cloneDeep({ ...UPDATER }));
    const [mode, setMode] = useState('suricata');
    // const [changes, setChanges] = useState(false);
    const [rulesCount, setRulesCount] = useState(0);
    const [otherGroupPolicies, setOtherGroupPolicies] = useState([]);
    const [ruleSelected, setRuleSelected] = useState('');
    const groupsRef = useRef();
    // const rulesRef = useRef();
    const suriPerms = Auth.permissions.get('SuricataRulesPolicy');
    const [readonly] = useState(!suriPerms.write);
    const [managedStatus, setManagedStatus] = useState(false);
    const [init, setInit] = useState(true);
    const [groupsChanged, setGroupsChanged] = useState(0);
    const [rulesChanged, setRulesChanged] = useState(0);
    const [loadingGroups, setLoadingGroups] = useState(true);
    const [loadingRules, setLoadingRules] = useState(true);
    const [revert, setRevert] = useState(0);
    const [searchContext, setSearchContext] = useState('groups');
    const [pushing, setPushing] = useState(false);

    useEffect(() => {
        const routeQuery = readRouteQuery();
        setTimeout(() => {
            if (routeQuery.group) {
                setGroupSearch({
                    ...groupSearch,
                    search: routeQuery.group,
                });
            }
            if (routeQuery.search) {
                setRuleSearch({
                    ...ruleSearch,
                    search: routeQuery.search,
                });
            }
            initiate();
        });
        getManagedStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initiate = () => {
        checkShadowPolicy(sh => {
            if (sh) {
                setTimeout(() => {
                    setInit(false);
                    setShadow(sh);
                });
            }
        });
    };

    useEffect(() => {
        if (!init) {
            setTimeout(() => {
                setLoadingRules(true);
                setRuleSearch(prev => {
                    if (prev.group === selectedGroup && prev.page === 0) return prev;
                    return { ...prev, group: selectedGroup, page: 0 };
                });
                setUpdater(prev => {
                    const u = { ...prev };
                    delete u.modifier_rule.enabled;
                    delete u.modifier_rule.keep;
                    if (JSON.stringify(prev) === JSON.stringify(u)) return prev;
                    return u;
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroup]);

    useEffect(() => {
        if (shadow?.uuid) {
            getPolicyGroups();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shadow]);

    // useEffect(() => {
    //     setChanges(_isEqual(UPDATER, updater));
    // }, [updater]);

    const groupSearchTimeout = useRef();
    const ruleSearchTimeout = useRef();
    const updaterTimeout = useRef();
    useEffect(() => {
        if (!init && shadow ) {
            setLoadingGroups(true);
            clearTimeout(groupSearchTimeout.current);
            groupSearchTimeout.current = setTimeout(() => {
                getPolicyGroups();
            }, 250);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupSearch]);

    useEffect(() => {
        if (!init && shadow) {
            setLoadingRules(true);
            clearTimeout(ruleSearchTimeout.current);
            ruleSearchTimeout.current = setTimeout(() => {
                getPolicyRules();
            }, 250);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ruleSearch]);

    useEffect(() => {
        if (!init && shadow) {
            clearTimeout(updaterTimeout.current);
            updaterTimeout.current = setTimeout(() => {
                handleUpdateShadow();
            }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updater]);

    const handleUpdateShadow = useCallback(() => {
        SuricataService.updateShadowPolicy(params.policy, shadow.uuid, {
            ...updater,
            search: searchContext === 'groups' ? groupSearch.search : ruleSearch.search,
            exact: searchContext === 'groups' ? groupSearch.exact : ruleSearch.exact,
            selector_group: groupSearch,
            selector_rule: ruleSearch,
        }).then(res => {
             if (updater?.modifier_group) {
                getPolicyGroups();
                }
        }, err => {
            console.error(err);
        });
    },[updater, groupSearch, ruleSearch, shadow, params.policy, searchContext]);

    const getManagedStatus = () => {
        SuricataService.isManaged().then(res => {
            setManagedStatus(res.managed);
        }, err => {
            console.error('Unable to get managed status ::: ', err);
        });
    };

    const checkShadowPolicy = (cb) => {
        SuricataService.checkShadowPolicy(params.policy).then(res => {
            if (res?.uuid) {
                SuricataService.getShadowPolicy(params.policy, res.uuid).then(r => {
                    const rUUID = { ...r, uuid: res.uuid };
                    cb(rUUID);
                }, err => {
                    console.error('Unable to get shadow policy ::: ', err);
                });
            }
        }, () => {
            SuricataService.createShadowPolicy(params.policy).then(r => {
                cb(r);
            }, err => {
                console.error('Unable to create shadow policy ::: ', err);
            });
            cb(undefined);
        });
    };

    const checkChangeCounts = (changes) => {
        if (_has(changes, 'modified_groups')) {
            setGroupsChanged(changes.modified_groups);
        }
        if (_has(changes, 'modified_rules')) {
            setRulesChanged(changes.modified_rules);
        }
    };

    const getPolicyGroups = () => {
        if (!init) {
            setLoadingGroups(true);
            SuricataService.getShadowPolicyGroups(params.policy, shadow.uuid, groupSearch).then(res => {
                if (!_has(res.policy, 'groups')) {
                    res.policy.groups = [];
                }
                checkChangeCounts(res);
                setTimeout(() => {
                    if (groupSearch.page !== 0) {
                        if (Object.prototype.hasOwnProperty.call(res.policy, 'groups')) {
                            setGroups({
                                ...res.policy,
                                groups: Array.prototype.concat(groups.groups, res.policy.groups),
                            });
                        }
                    } else {
                        setGroups(res.policy);
                        if (res.policy.groups.length === 1) {
                            setSelectedGroup(res.policy.groups[0].name);
                            groupsRef.current && groupsRef.current.updateSelection(res.policy.groups[0]);
                        }
                    }

                    if (Object.prototype.hasOwnProperty.call(res.policy, 'groups') && res.policy.groups.length) {
                        getPolicyRules();
                    } else {
                        setLoadingRules(false);
                    }
                    setRulesCount(res.policy.enabled_enabled_rules);
                    setLoadingGroups(false);
                });
            }, err => {
                console.error('Unable to get Suricata groups ::: ', err);
                setLoadingGroups(false);
            });
        }
    };

    const getPolicyRules = () => {
        if (!init && ruleSearch) {
            setLoadingRules(true);
            SuricataService.getShadowPolicyRules(params.policy, shadow.uuid, ruleSearch).then(res => {
                checkChangeCounts(res);
                if (!res.policy.rules) {
                    res.policy.rules = [];
                }

                if (ruleSearch.page !== 0) {
                    setRules({
                        ...res.policy,
                        rules: Array.prototype.concat(rules.rules, res.policy.rules),
                    });
                } else {
                    setRules(res.policy);
                }
                setLoadingRules(false);
            }, err => {
                console.error('Unable to get Suricata rules ::: ', err);
                setLoadingRules(false);
            });

            if (ruleSearch.group) {
                SuricataService.getPoliciesWithGroupEnabled(ruleSearch.group).then(res => {
                    setOtherGroupPolicies(res);
                });
            }
        }
    };

    const readRouteQuery = () => {
        const routeQuery = new URLSearchParams(location.search);
        if (routeQuery.toString().length < 1) return {};
        return {
            group: routeQuery.has('group') ? routeQuery.get('group') : undefined,
            search: routeQuery.has('search') ? routeQuery.get('search') : undefined,
        };
    };

    const handleRevertPolicy = () => {
        setTimeout(() => {
            setShadow(null);
            setUpdater(_cloneDeep({ ...UPDATER }));
            setGroupSearch(_cloneDeep({ ...SEARCH }));
            setRuleSearch(_cloneDeep({ ...SEARCH }));
        });
        SuricataService.deleteShadowPolicy(params.policy).then(res => {
            setInit(true);
            initiate();
            setRevert(revert + 1);
        }, err => {
            console.error('Unable to delete shadow policy ::: ', err);
        });
    };

    const handlePushPolicy = () => {
        setMode('push');
    };

    const handleDeployPolicy = (sensorList) => {
        setPushing(true);
        SuricataService.saveShadowPolicy(params.policy, shadow.uuid).then(() => {
            toast.success('Suricata policy saved successfully');
            setMode('suricata');

            if (sensorList.length || Object.keys(sensorList).length) {
                PolicyService.assignPolicy('suricata_rules', params.policy, sensorList).then(() => {
                    toast.success('Policy push to additional sensors was successful');
                }, err => {
                    toast.error('Failed to push policy to additional sensors...');
                    console.error(err);
                });
            }
            setTimeout(() => {
                setUpdater(_cloneDeep({ ...UPDATER }));
                initiate();
            }, 3000);
        }, err => {
            if (err) {
                toast.error(err.message + ': ' + err.error);
            }
        }).finally(() => { setPushing(false) });
    };

    const handleModeChange = () => {
        setMode('suricata');
    };

    const handleGoToEditor = () => {
        navigate('/policies/suricata/rules/editor', {
            state
                : { prevPath: '/policies/suricata/rules/default' }
        });
    };

    const handleRuleSelection = (row) => {
        if (row && row.length) {
            setRuleSelected(row[0]);
            setMode('rule');
        }
    };

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid container item xs={12} style={{ display: mode !== 'suricata' ? 'none' : 'flex' }} justifyContent="space-between">
                    <Box display="flex">
                        {/* <Box className={classes.suriDetails}>
                            <Typography variant="body2">SENSORS</Typography>
                            <Box>{sensorCount}</Box>
                        </Box> */}
                        {/* <Box className={classes.suriDetails}>
                            <Typography variant="body2">GROUPS ENABLED</Typography>
                            <Typography variant="body2">{groupsCount}</Typography>
                        </Box> */}
                        <Box className={classes.suriDetails}>
                            <Typography variant="body2">RULES ENABLED</Typography>
                            <Typography variant="body2">{rulesCount}</Typography>
                            {/* <Box>{rulesCount}</Box> */}
                        </Box>
                        <Box className={classes.suriDetails}>
                            <Typography variant="body2">GROUPS CHANGED</Typography>
                            <Typography variant="body2">{groupsChanged}</Typography>
                        </Box>
                        <Box className={classes.suriDetails}>
                            <Typography variant="body2">RULES CHANGED</Typography>
                            <Typography variant="body2">{rulesChanged}</Typography>
                        </Box>
                    </Box>
                    {!readonly && <Box display="flex">
                        {managedStatus
                            ? <Tooltip title="Rules must be managed by the MC2."><Box ml={1}><Button disabled variant="contained" color="inherit" aria-label="editor">Editor</Button></Box></Tooltip>
                            : <Box ml={1}><Button variant="contained" color="inherit" aria-label="editor" onClick={handleGoToEditor}>Editor</Button></Box>
                        }
                        {suriPerms.admin && <Box ml={1}><Button
                            variant="contained"
                            color="primary"
                            aria-label="push"
                            onClick={handlePushPolicy}
                        // disabled={!changes}
                        // className={clsx({
                        //     [classes.pushAnimation]: changes,
                        // })}
                        >Push
                        </Button></Box>}
                        <Box ml={1}><Button variant="contained" color="secondary" aria-label="revert" onClick={handleRevertPolicy}>Revert</Button></Box>
                    </Box>}
                </Grid>
                <Box display={mode === 'push' ? 'block' : 'none'}>
                    {suriPerms.admin && <Push
                        pushClasses={classes.buttonRight}
                        policyName={params.policy}
                        policyType={'suricata_rules'}
                        onDeploy={handleDeployPolicy}
                        closePush={() => { handleModeChange('suricata') }}
                        pushing={pushing}
                        permName={'SuricataRulesPolicy'}
                    />}
                </Box>
                <Box display={mode === 'rule' ? 'block' : 'none'} width="100%">
                    {mode === 'rule' && <Rule
                        ruleID={ruleSelected}
                        updateMod={() => { }}
                        updateMode={setMode}
                        updater={updater}
                        updateUpdater={setUpdater}
                    />}
                </Box>
                <Grid container item xs={12} spacing={2} style={{ display: mode !== 'suricata' ? 'none' : '' }}>
                    <Groups
                        ref={groupsRef}
                        col={4}
                        policy={params.policy}
                        groups={groups}
                        rules={rules}
                        updater={updater}
                        updateUpdater={setUpdater}
                        groupSearch={groupSearch}
                        updateGroupSearch={setGroupSearch}
                        getGroups={getPolicyGroups}
                        otherGroupPolicies={otherGroupPolicies}
                        selectedGroup={selectedGroup}
                        updateSelected={setSelectedGroup}
                        updatePrev={setPrevGroup}
                        readonly={readonly}
                        managed={managedStatus}
                        loading={readonly ? false : loadingGroups}
                        revert={revert}
                        updateSearchContext={setSearchContext}
                    />
                    <Rules
                        col={8}
                        policy={params.policy}
                        groups={groups}
                        rules={rules}
                        updater={updater}
                        updateUpdater={setUpdater}
                        ruleSearch={ruleSearch}
                        updateRuleSearch={setRuleSearch}
                        getRules={getPolicyRules}
                        getGroups={getPolicyGroups}
                        selectedGroup={selectedGroup}
                        prevGroup={prevGroup}
                        updatePrev={setPrevGroup}
                        handleRuleSelection={handleRuleSelection}
                        readonly={readonly}
                        managed={managedStatus}
                        loading={readonly ? false : loadingRules}
                        revert={revert}
                        updateSearchContext={setSearchContext}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default SuricataRules;
